import React from "react";
import MenuItem from "@mui/material/MenuItem";

import { useSnackbar } from "components/haven-design/snackbar";
import { useInterestsTable } from "../interests-table/table-context";
import { getBulkLimitError, MAX_BULK_ACTION_APPLICANTS } from "./utils";

type Props = {
  selectedInterestIds: string[];
  closeMenu: () => void;
  setAddNoteModalOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const AddNoteButton: React.FC<Props> = (props) => {
  const { closeMenu, setAddNoteModalOpen } = props;
  const { openSnackbar } = useSnackbar();
  const { totalSelectedInterests } = useInterestsTable();

  const showError = (message: string) => {
    setTimeout(() => openSnackbar({ message, status: "error", duration: 5000 }), 100);
  };

  const open = () => {
    // Select-all and page ranges are allowed as long as the selection fits the cap.
    const error = getBulkLimitError(totalSelectedInterests, {
      empty: "Please select interests to add a note.",
      overLimit: `Notes can be added to at most ${MAX_BULK_ACTION_APPLICANTS} applicants at once`,
    });
    if (error) showError(error);
    else setAddNoteModalOpen(true);
    closeMenu();
  };


  return (
    <MenuItem id="actions-add-note" onMouseUp={open}>
      Add Note {`(${totalSelectedInterests})`}
    </MenuItem>
  );
};

export default AddNoteButton;
